var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "div side-right", class: { open: _vm.open } },
    [
      _c("transition", { attrs: { name: "fade" } }, [_c("section-login")], 1),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c("section-user", {
            scopedSlots: _vm._u(
              [
                {
                  key: "panel-section-user",
                  fn: function () {
                    return [_vm._t("panel-section-user")]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_vm._t("others-panels")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }